// eslint-disable-next-line import/prefer-default-export
export const getSessionToken = ({ state = {} }) => {
    // eslint-disable-next-line camelcase
    const { access_token, sessionToken } = state.session?.auth || {};
    // eslint-disable-next-line camelcase
    return access_token || sessionToken;
};
